<template>
  <div>
    <div class="head-banner"></div>
    <div class="nav-btn">
      <!-- <span
              :class="{'nav-active':$route.path=='/supplier/registration'}"
              @click="$router.push({name:'supplier-registration'})"
            >供应商注册</span>-->
      <!-- <span
              :class="{'nav-active':$route.path=='/distributor/registration'}"
              @click="$router.push({name:'distributor-registration'})"
            >企业用户</span>
            <span
              :class="{'nav-active':$route.path=='/personage-register'}"
              @click="$router.push({name:'personage-register'})"
            >临时分销渠道</span>-->
    </div>
    <div
      class="warning"
      v-show="$route.query.type"
    >
      <i class="el-icon-warning-outline"></i>
      <p>抱歉，您的信息审核不通过，失败原因：{{ formData.failReason }}</p>
    </div>
    <div class="content">
      <div class="form-data-info">
        <div class="form-data-head">账号信息</div>
        <div class="form-data-input">
          <div class="user_type">
            <!-- <el-radio-group v-model="userType" @change="goRegister">
                          <el-radio label="distributor-registration">机票分销商</el-radio>
                          <el-radio label="distributor-registration">旅游分销商</el-radio>
                          <el-radio label="personage-register">临时分销渠道</el-radio>
                        </el-radio-group>-->
            <div style="width: 33%">账户类型：</div>
            <div style="transform: translate(-100px, 0)">
              <el-radio-group
                v-model="formData.buyerType"
                @change="goRegister"
                :disabled="$route.query.type ? true : false"
              >
                <el-radio label="1">机票分销商</el-radio>
                <el-tooltip
                  class="item"
                  effect="dark"
                  content="合作：机票+旅游（包含酒店、门票、签证、跟团游等）"
                  placement="top"
                >
                  <el-radio label="1+2">旅行社</el-radio>
                </el-tooltip>
                <el-tooltip
                  class="item"
                  effect="dark"
                  content="合作：机票、酒店、门票等单品类（不接受旅游线路合作）"
                  placement="top"
                >
                  <el-radio label="3">商务代理</el-radio>
                </el-tooltip>
              </el-radio-group>
              <!-- <el-radio
                              @change="goRegister('distributor-registration',1)"
                              v-model="registrationList.a"
                            >机票分销商</el-radio>
                            <el-radio
                              @change="goRegister('distributor-registration',2)"
                              v-model="registrationList.b"
                            >旅游分销商</el-radio>
                            <el-radio @change="goRegister('personage-register')" v-model="userType">临时分销渠道</el-radio>-->
            </div>
          </div>
          <el-form
            label-width="170px"
            :model="formData"
            :rules="rules"
            ref="userForm"
            status-icon
            v-if="!personShow"
          >
            <el-form-item
              label="账号:"
              prop="userName"
            >
              <el-input
                v-model="formData.userName"
                placeholder="请输入账号"
                @blur="queryUserName"
                maxlength="20"
                :disabled="$route.query.type ? true : false"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="密码:"
              prop="password"
            >
              <el-input
                v-model="formData.password"
                type="password"
                placeholder="请输入密码"
                autocomplete="off"
                maxlength="20"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="确认密码:"
              prop="passwordAgain"
            >
              <el-input
                v-model="formData.passwordAgain"
                type="password"
                placeholder="请再次输入密码"
                autocomplete="off"
                maxlength="20"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="手机号:"
              prop="phone"
            >
              <div class="flex-center-start">
                <el-input
                  v-model="formData.phone"
                  placeholder="请输入手机号"
                ></el-input>
                <el-button
                  class="code-btn flex-center"
                  :loading="getCodePhone.statu"
                  @click="getNote"
                  :disabled="getCodePhone.show"
                >
                  <span v-show="getCodePhone.show">{{ getCodePhone.num }}秒</span>
                  {{ getCodePhone.text }}
                </el-button>
              </div>
            </el-form-item>
            <el-form-item
              label="短信验证码:"
              prop="smsCode"
            >
              <el-input
                v-model="formData.smsCode"
                placeholder="请输入短信验证码"
              ></el-input>
            </el-form-item>
          </el-form>
        </div>
        <div v-if="!personShow">
          <div class="form-data-head">企业信息</div>
          <div class="form-data-input">
            <el-form
              label-width="170px"
              :model="formData"
              :rules="rules"
              ref="companyForm"
            >
              <el-form-item
                label="公司名称:"
                prop="companyName"
              >
                <el-input
                  v-model="formData.companyName"
                  placeholder="请输入公司名称"
                ></el-input>
              </el-form-item>
              <el-form-item
                label="所属城市:"
                prop="areaCitys"
              >
                <el-col :span="8">
                  <el-select
                    v-model="formData.areaRegions"
                    placeholder="请选择大区"
                    @change="_getArea"
                  >
                    <el-option
                      v-for="item in siteList.area"
                      :key="item.id"
                      :label="item.areaName"
                      :value="[item.id, item.areaName]"
                    ></el-option>
                  </el-select>
                </el-col>
                <el-col
                  :span="8"
                  style="padding: 0 10px"
                >
                  <el-select
                    v-model="formData.areaProvinces"
                    placeholder="请选择省份"
                    @change="_getProvince"
                  >
                    <el-option
                      v-for="item in siteList.province"
                      :key="item.id"
                      :label="item.areaName"
                      :value="[item.id, item.areaName]"
                    ></el-option>
                  </el-select>
                </el-col>
                <el-col :span="8">
                  <el-select
                    v-model="formData.areaCitys"
                    placeholder="请选择城市"
                  >
                    <el-option
                      v-for="item in siteList.city"
                      :key="item.id"
                      :label="item.areaName"
                      :value="[item.id, item.areaName]"
                    ></el-option>
                  </el-select>
                </el-col>
              </el-form-item>
              <el-form-item
                label="公司地址:"
                prop="companyAddress"
              >
                <el-input
                  v-model="formData.companyAddress"
                  placeholder="请输入公司地址"
                ></el-input>
              </el-form-item>
              <el-form-item label="传真:">
                <!-- <div style="width:100px;display:inline-block">
                                   <el-input v-model="formData.financeFaxZone" placeholder="区号"></el-input>
                                </div>-->
                <div style="width: 200px; display: inline-block">
                  <el-input
                    v-model="formData.financeFax"
                    placeholder="传真号"
                  ></el-input>
                </div>
              </el-form-item>
              <el-form-item
                label="统一社会信用代码:"
                prop="businessLicenseNum"
              >
                <el-input
                  v-model="formData.businessLicenseNum"
                  placeholder="请输入统一社会信用代码"
                ></el-input>
              </el-form-item>
              <el-form-item
                label="统一社会信用代码图片:"
                prop="businessLicensePic"
              >
                <el-upload
                  class="avatar-uploader"
                  action="#"
                  :show-file-list="false"
                  :before-upload="detectionImg"
                  :http-request="(res) => uploadChange(res, 'businessLicensePic', 'companyForm')"
                  :file-list="fileListImg['businessLicensePic']"
                  accept="image/jpg, image/jpeg, image/x-png"
                  v-loading="uploadLoading['businessLicensePic']"
                >
                  <img
                    v-if="imageUrl['businessLicensePic']"
                    :src="imageUrl['businessLicensePic']"
                    class="avatar"
                  >
                  <i
                    v-else
                    class="el-icon-plus avatar-uploader-icon"
                  ></i>
                </el-upload>
              </el-form-item>
              <el-form-item label="法人身份证号码:">
                <el-input
                  v-model="formData.idCard"
                  placeholder="请输入身份证号"
                ></el-input>
              </el-form-item>
              <el-form-item label="法人代表身份证:">
                <div class="form-item-card">
                  <p class="form-item-card-title">请上传身份证(正面)</p>
                  <el-upload
                    class="avatar-uploader"
                    action="#"
                    :show-file-list="false"
                    :before-upload="detectionImg"
                    :http-request="(res) => uploadChange(res, 'idCardFront')"
                    :file-list="fileListImg['idCardFront']"
                    accept="image/jpg, image/jpeg, image/x-png"
                    v-loading="uploadLoading['idCardFront']"
                  >
                    <img
                      v-if="imageUrl['idCardFront']"
                      :src="imageUrl['idCardFront']"
                      class="avatar"
                    >
                    <i
                      v-else
                      class="el-icon-plus avatar-uploader-icon"
                    ></i>
                  </el-upload>
                </div>
                <div class="form-item-card">
                  <p class="form-item-card-title">请上传身份证(反面)</p>
                  <el-upload
                    class="avatar-uploader"
                    action="#"
                    :show-file-list="false"
                    :before-upload="detectionImg"
                    :http-request="(res) => uploadChange(res, 'idCardReverse')"
                    :file-list="fileListImg['idCardReverse']"
                    accept="image/jpg, image/jpeg, image/x-png"
                    v-loading="uploadLoading['idCardReverse']"
                  >
                    <img
                      v-if="imageUrl['idCardReverse']"
                      :src="imageUrl['idCardReverse']"
                      class="avatar"
                    >
                    <i
                      v-else
                      class="el-icon-plus avatar-uploader-icon"
                    ></i>
                  </el-upload>
                </div>
              </el-form-item>
            </el-form>
          </div>
          <div
            class="form-data-head"
            v-show="formData.buyerType == 1 || formData.buyerType == '1+2'"
          >
            机票资质信息
          </div>
          <div
            class="form-data-input"
            v-show="formData.buyerType == 1 || formData.buyerType == '1+2'"
          >
            <el-form
              label-width="170px"
              :model="formData"
              :rules="rules"
              ref="airForm"
            >
              <el-form-item label="OfficeID:">
                <el-input
                  v-model="formData.officeId"
                  placeholder="请输入OfficeID"
                ></el-input>
              </el-form-item>
              <el-form-item
                label="联系人:"
                prop="airLinkman"
              >
                <el-input
                  v-model="formData.airLinkman"
                  placeholder="请输入联系人"
                ></el-input>
              </el-form-item>
              <el-form-item
                label="手机号:"
                prop="airPhone"
              >
                <el-input
                  v-model="formData.airPhone"
                  placeholder="请输入手机号"
                ></el-input>
              </el-form-item>
              <el-form-item label="电子邮箱:">
                <el-input
                  v-model="formData.airEmail"
                  placeholder="请输入电子邮箱"
                ></el-input>
              </el-form-item>
              <el-form-item label="联系人QQ:">
                <el-input
                  v-model="formData.airQq"
                  placeholder="请输入联系人QQ"
                ></el-input>
              </el-form-item>
            </el-form>
            <div
              class="form-data-submit"
              v-show="formData.buyerType != '1+2'"
            >
              <div class="form-data-sub-box">
                <div class="form-data-sub-text flex-center-start">
                  <el-checkbox v-model="agreeStatu"></el-checkbox>
                  <span>
                    我已同意
                    <span
                      class="cursor"
                      style="color: #237dc8"
                      @click="protocolText.show = true"
                    >《{{ protocolText.title }}》</span>
                    <span
                      class="cursor"
                      style="color: #237dc8"
                      @click="protocolText.show1 = true"
                    >《{{ protocolText.title1 }}》</span>
                  </span>
                </div>
                <el-button
                  type="primary"
                  @click="submitForm"
                >立即提交</el-button>
              </div>
            </div>
          </div>
          <div
            class="form-data-head"
            v-show="formData.buyerType == 2 || formData.buyerType == '1+2'"
          >
            旅游资质信息
          </div>
          <div
            class="form-data-input"
            v-show="formData.buyerType == 2 || formData.buyerType == '1+2'"
          >
            <el-form
              label-width="170px"
              :model="formData"
              ref="travelForm"
              :rules="rules"
            >
              <el-form-item
                label="旅游经营许可证:"
                prop="touristBusinessLicenseNumber"
              >
                <el-input
                  v-model="formData.touristBusinessLicenseNumber"
                  placeholder="请输入旅游经营许可证"
                ></el-input>
              </el-form-item>
              <el-form-item
                label="旅游经营许可证照片:"
                prop="touristBusinessLicense"
              >
                <el-upload
                  class="avatar-uploader"
                  action="#"
                  :show-file-list="false"
                  :before-upload="detectionImg"
                  :http-request="(res) => uploadChange(res, 'touristBusinessLicense', 'travelForm')"
                  :file-list="fileListImg['touristBusinessLicense']"
                  accept="image/jpg, image/jpeg, image/x-png"
                  v-loading="uploadLoading['touristBusinessLicense']"
                >
                  <img
                    v-if="imageUrl['touristBusinessLicense']"
                    :src="imageUrl['touristBusinessLicense']"
                    class="avatar"
                  >
                  <i
                    v-else
                    class="el-icon-plus avatar-uploader-icon"
                  ></i>
                </el-upload>
              </el-form-item>
              <el-form-item label="公章:">
                <el-upload
                  class="avatar-uploader"
                  action="#"
                  :show-file-list="false"
                  :before-upload="detectionImg"
                  :http-request="(res) => uploadChange(res, 'commonSeal')"
                  :file-list="fileListImg['commonSeal']"
                  accept="image/jpg, image/jpeg, image/x-png"
                  v-loading="uploadLoading['commonSeal']"
                >
                  <img
                    v-if="imageUrl['commonSeal']"
                    :src="imageUrl['commonSeal']"
                    class="avatar"
                  >
                  <i
                    v-else
                    class="el-icon-plus avatar-uploader-icon"
                  ></i>
                </el-upload>
              </el-form-item>
              <el-form-item
                label="联系人:"
                prop="travelLinkman"
              >
                <el-input
                  v-model="formData.travelLinkman"
                  placeholder="请输入联系人"
                ></el-input>
              </el-form-item>
              <el-form-item
                label="手机号:"
                prop="travelPhone"
              >
                <el-input
                  v-model="formData.travelPhone"
                  placeholder="请输入手机号"
                ></el-input>
              </el-form-item>
              <el-form-item label="电子邮箱:">
                <el-input
                  v-model="formData.travelEmail"
                  placeholder="请输入电子邮箱"
                ></el-input>
              </el-form-item>
              <el-form-item label="联系人QQ:">
                <el-input
                  v-model="formData.travelQq"
                  placeholder="请输入联系人QQ"
                ></el-input>
              </el-form-item>
            </el-form>
            <div class="form-data-submit">
              <div class="form-data-sub-box">
                <div class="form-data-sub-text flex-center-start">
                  <el-checkbox v-model="agreeStatu"></el-checkbox>
                  <span>
                    我已同意
                    <span
                      class="cursor"
                      style="color: #237dc8"
                      @click="protocolText.show = true"
                    >《{{ protocolText.title }}》</span>
                    <span
                      class="cursor"
                      style="color: #237dc8"
                      @click="protocolText.show1 = true"
                    >《{{ protocolText.title1 }}》</span>
                  </span>
                </div>
                <el-button
                  type="primary"
                  @click="submitForm"
                >立即提交</el-button>
              </div>
            </div>
          </div>
        </div>
        <personage-component
          v-if="personShow"
          :personShow="personShow"
          @getFailReason="getFailReason"
        ></personage-component>
      </div>
      <div class="form-data-text">
        <div class="text-box">
          <div class="form-data-head">合作流程</div>
          <ul>
            <li>第一步：注册账号</li>
            <li>第二步：后台人工审核</li>
            <li>第三步：完成开通</li>
            <li>第四步：签订合作协议</li>
          </ul>
        </div>
        <div>
          <div class="form-data-head">注册须知</div>
          <ul>
            <li style="font-weight: bold; color: red">
              1、平台账号签约前仅可浏览内容，必须“签约”后才能正常提交订单。
            </li>
            <li>2、提交注册申请前，请您提供真实有效的企业资质；</li>
            <li>
              3、在线提交注册申请时，请您根据提示说明认真填写，并与正本资料仔细核对，确保信息一致；
            </li>
            <li>
              4、平台哪些类型的产品可以合作？以下产品可以合作：跟团游，定制，度假，门票，酒店，机票，签证、租车及其他旅游相关服务；具体要以签约产品类型进行合作；
            </li>
            <li>
              5、我可以注册两个或两个以上的胤之旅账户吗？胤之旅的会员账户与手机绑定，一个手机只能注册一个账户并成为管理员。管理员可以添加不同的一个以上的子账户并可以为子账号分配权限；
            </li>
            <li>
              6、提交合作信息申请后胤之旅会在1-2个工作日内回复，请留意短信或邮箱信息。也可致电400-626-8448联系客服。
            </li>
          </ul>
        </div>
      </div>
    </div>
    <el-dialog
      title="图片验证"
      :visible.sync="authCode.show"
      :close-on-click-modal="false"
      width="300px"
    >
      <div class="flex-center code-auth">
        <img
          :src="authCode.url"
          alt=""
        />
        <el-input
          v-model="authCode.value"
          ref="authCode"
          @keydown.enter.native="getPhoneAuthCode"
        ></el-input>
      </div>
      <span
        slot="footer"
        class="dialog-footer"
      >
        <el-button
          type="primary"
          @click="getPhoneAuthCode"
          size="small"
        >确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      :visible.sync="protocolText.show"
      width="800px"
    >
      <div
        v-html="protocolText.text"
        style="text-align: justify"
      ></div>
    </el-dialog>
    <el-dialog
      :visible.sync="protocolText.show1"
      width="800px"
    >
      <div
        v-html="protocolText.text1"
        style="text-align: justify"
      ></div>
    </el-dialog>
  </div>
</template>
<script>
import Q from "q";
import _ from 'underscore';

import userBuyer from "@/lib/data-service/default/web_common_userBuyer_new";
import getInlandAreaChildListByParentIdResponse from "@/lib/data-service/default/web_common_area_getInlandAreaChildListByParentIdResponse";
import kaptcha from "@/lib/data-service/default/web_common_kaptcha";
import phoneRegister from "@/lib/data-service/default/web_common_register";
import vueCheckUserName from "@/lib/data-service/default/web_common_user_vueCheckUserName";
import web_common_user_checkPhone from "@/lib/data-service/default/web_common_user_checkPhone";
import { STATUS } from "@/lib/deprecated/utils/status";

import get_url_prefix from "yinzhilv-js-sdk/frontend/common-project/lib/common-service/get_url_prefix";
import liability from "@/page/distributor/other/aboutUs/text/liability";
import knowledge from "@/page/distributor/other/aboutUs/text/knowledge";
import { resolve } from "q";
import OssClient from "yinzhilv-js-sdk/frontend/common-project/lib/system-docking/aliyun/oss/frontend/client";
import personageComponent from "@/page/supplier/personageRegister";
import userBuyer_findOne from "@/lib/data-service/default/web_common_userBuyer_findOne";
import updateBuyer from "@/lib/data-service/default/web_common_userBuyer_updateBuyer";
import verification from "@/lib/deprecated/utils/verification/1.0.2";
const SUCCESS_CODE = STATUS.success;
export default {
  data() {
    return {
      formData: {
        userName: "",
        airEmail: "",
        airLinkman: "",
        airPhone: "",
        airQq: "",
        areaCity: "",
        areaCityName: "",
        areaProvince: "",
        areaProvinceName: "",
        areaRegion: "",
        areaRegionName: "",
        businessLicenseNum: "",
        businessLicensePic: "",
        buyerLevel: 0,
        buyerType: "1",
        carryRules: 0,
        commonSeal: "",
        companyAddress: "",
        companyId: 0,
        companyName: "",
        creditId: 0,
        financeFax: "",
        idCard: "",
        idCardFront: "",
        idCardReverse: "",
        officeId: "",
        password: "",
        phone: "",
        smsCode: "",
        touristBusinessLicense: "",
        touristBusinessLicenseNumber: "",
        travelEmail: "",
        travelLinkman: "",
        travelPhone: "",
        travelQq: "",
        userName: "",
        areaCitys: [],
      },
      selectCityStatu: false,
      ossClient: new OssClient(),
      personShow: false,
      protocolText: {
        show: false,
        show1: false,
        text: liability,
        text1: knowledge,
        title: "网站声明",
        title1: "知识产权声明",
      },
      fileListImg: {
        idCardFront: [],
        idCardReverse: [],
        businessLicensePic: [],
        commonSeal: [],
        touristBusinessLicense: [],
      },
      imageUrl: {
        businessLicensePic: '',
        idCardFront: '',
        idCardReverse: '',
        touristBusinessLicense: '',
        commonSeal: '',
      },
      uploadLoading: {
        businessLicensePic: false,
        idCardFront: false,
        idCardReverse: false,
        touristBusinessLicense: false,
        commonSeal: false,
      },
      authCode: {
        url: "",
        value: "",
        show: false,
      },
      getCodePhone: {
        staut: false,
        show: false,
        num: 60,
        text: "获取短信验证码",
      },
      phoneStatu: false,
      agreeStatu: false,
      registrationList: {},
      userType: "distributor-registration",
      siteList: {}, //地址
      options: [],
      password: "",
      rules: {
        //验证
        userName: [
          {
            validator: verification.checkUser,
            trigger: "blur",
            required: true,
          },
        ],
        password: [
          {
            validator: verification.checkPassWord,
            trigger: "blur",
            required: true,
          },
        ],
        passwordAgain: [
          {
            validator: verification.validatePass,
            trigger: "blur",
            required: true,
          },
        ],
        phone: [
          {
            validator: verification.checkPhone,
            trigger: "blur",
            required: true,
          },
        ],
        smsCode: [{ required: true, message: "请输入验证码", trigger: "blur" }],
        companyName: [
          { required: true, message: "请输入公司名称", trigger: "blur" },
        ],
        companyAddress: [
          { required: true, message: "请输入公司地址", trigger: "blur" },
        ],
        businessLicenseNum: [
          {
            validator: verification.checkBusinessLicense,
            trigger: "blur",
            required: true,
          },
        ],
        businessLicensePic: [
          {
            required: true,
            message: "请上传统一社会信用代码图片",
            trigger: "blur",
          },
        ],
        airLinkman: [
          { required: true, message: "请输入联系人", trigger: "blur" },
        ],
        airPhone: [
          {
            validator: verification.checkPhone,
            trigger: "blur",
            required: true,
          },
        ],
        travelLinkman: [
          { required: true, message: "请输入联系人", trigger: "blur" },
        ],
        travelPhone: [
          {
            validator: verification.checkPhone,
            trigger: "blur",
            required: true,
          },
        ],
        areaCitys: [{ required: true, message: "请选择城市", trigger: "blur" }],
        touristBusinessLicenseNumber: [
          {
            validator: verification.checkTouristBusinessLicenseNumber,
            trigger: "blur",
            required: true,
          },
        ],
        touristBusinessLicense: [
          {
            validator: verification.checkTouristBusinessLicensePic,
            required: true,
          },
        ],
        idCard: [
          {
            required: true,
            validator: verification.checkId,
            trigger: "blur",
          },
        ],
      },
    };
  },
  components: { personageComponent },
  created() {
    this._getInlandArea("100000", (res) => {
      this.$set(this.siteList, "area", res);
    });
    verification.self = this;
    if (this.$route.query.type == 3) {
      this.formData.buyerType = "3";
      this.personShow = true;
    } else if (this.$route.query.type) {
      let id = this.$route.query.id;

      this.getInfo(id);
    }
  },
  watch: {
    formData: {
      handler(newVal) {
        verification.formData = newVal;
      },
      deep: true,
    },
  },
  methods: {
    getInfo(buyerId) {
      userBuyer_findOne({ buyerId }).then((res) => {
        let data = Object.assign(this.formData, res.result);
        let imgList = [
          "businessLicensePic",
          "idCardFront",
          "idCardReverse",
          "touristBusinessLicense",
          "commonSeal",
        ];
        imgList.map((name) => {
          if (data[name]) {
            this.fileListImg[name].push({
              name: name,
              url: data[name],
            });
            document.querySelector(`#${name} .el-upload`).style.display =
              "none";
          }
        });
        data.areaRegions = data.areaRegionName;
        data.areaProvinces = data.areaProvinceName;
        data.areaCitys = data.areaCityName;
        this.formData = data;
      });
    },
    getFailReason(val) {
      // this.formData.failReason = val;
      this.$set(this.formData, "failReason", val);
    },
    goRegister(type) {
      type == 3 ? (this.personShow = true) : (this.personShow = false);
      // this.$router.push({ name: path, query: { type: type } });
    },
    //获取产品图片上传的地址
    uploadChange(file, name, from) {
      this.$set(this.uploadLoading, name, true);
      this.ossClient.multipartUpload({
          file: file.file,
        })
        .then((res) => {
          this.formData[name] = res.url;
          this.$message({ type: "success", message: "上传图片成功" });
          if (name === "businessLicensePic") this.$refs[from].validateField("businessLicenseNum");
          if (name === 'touristBusinessLicense') this.$refs[from].validateField("touristBusinessLicenseNumber");
          this.$set(this.imageUrl, name, res.url)

          // this.$refs[from].validateField(name);
          // document.querySelector(`#${name} .el-upload`).style.display = "none";
        })
        .catch(() => {
          this.$message.error('上传图片失败');
        })
        .finally(() => {
           this.$set(this.uploadLoading, name, false);
        });
    },
    //检验img格式
    detectionImg(file) {
      var reg2 = /^(\s|\S)+(jpg|png|bmp|jpeg)+$/;
      const isLt2M = file.size / 1024 < 10240;
      if (!reg2.test(file.name)) {
        this.$message({ type: "warning", message: "图片格式上传错误！" });
        return false;
      }
      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 10M!");
        return false;
      }
    },
    //处理产品图片的删除
    handleRemoveImg(file, name, from) {
      this.formData[name] = "";
      name === "businessLicensePic"
        ? this.$refs[from].validateField("businessLicenseNum")
        : "";
      name === "touristBusinessLicense"
        ? this.$refs[from].validateField("touristBusinessLicenseNumber")
        : "";
      document.querySelector(`#${name} .el-upload`).style.display = "block";
    },
    //检查用户名
    queryUserName() {
      const name = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,20}$/;
      if (!this.formData.userName) {
        return;
      } else {
        if (!name.test(this.formData.userName)) return;
      }
      vueCheckUserName({ userName: this.formData.userName }).then((res) => {
        if (res.code === SUCCESS_CODE) {
          !res.flag
            ? this.$message({ type: "warning", message: "用户已注册" })
            : "";
        }
      });
    },
    //获取短信
    getNote() {
      let phoneReg = /^1[3|4|5|7|8][0-9]{9}$/;
      if (!this.formData.phone) {
        return this.$message({ type: "warning", message: "请输入手机号码" });
      } else {
        if (!phoneReg.test(this.formData.phone)) {
          return this.$message({
            type: "warning",
            message: "电话号码格式不正确",
          });
        }
      }
      this.authCode.value = "";
      this.authCode.show = true;
      kaptcha().then((res) => {
        if (res.code === SUCCESS_CODE) {
          this.authCode.url = res.img;
          this.authCode.uuid = res.uuid;
          this.$refs.authCode.focus();
        }
      });
    },
    //手机验证码
    getPhoneAuthCode() {
      let authCode = this.authCode;
      if (authCode.value) {
        authCode.show = false;
        let data = {
          phoneNumber: this.formData.phone,
          verificationCode: authCode.value,
          roleType: 2,
          uuid: authCode.uuid,
        };
        this.getCodePhone.statu = true;
        phoneRegister(data).then(
          (res) => {
            if (res.code === SUCCESS_CODE) {
              this.getCodePhone.statu = false;
              this.getCodePhone.show = true;
              this.getCodePhone.text = "重新发送";
              let codeNmu = setInterval(() => {
                this.getCodePhone.num--;
                if (this.getCodePhone.num < 1) {
                  clearInterval(codeNmu);
                  this.getCodePhone.text = "获取短信验证码";
                  this.getCodePhone.show = false;
                  this.getCodePhone.num = 60;
                }
              }, 1000);
            }
          },
          (error) => {
            this.getCodePhone.statu = false;
            this.$forceUpdate();
          }
        );
      }
    },
    //提交表单
    submitForm() {
      let formRuleName = [];
      let _this = this;
      let data = this.formData;
      this.formData.buyerType == 1
        ? (formRuleName = ["userForm", "companyForm", "airForm"])
        : this.formData.buyerType == 2
        ? (formRuleName = ["userForm", "companyForm", "travelForm"])
        : (formRuleName = ["userForm", "companyForm", "airForm", "travelForm"]);
      let statu = formRuleName.map((item) => {
        let _s = Boolean;
        this.$refs[item].validate((valid) => {
          if (valid) {
            _s = true;
            if (this.$route.query.type) {
              if (data.areaCitys && this.selectCityStatu) {
                data.areaRegion = data.areaRegions[0];
                data.areaProvince = data.areaProvinces[0];
                data.areaCity = data.areaCitys[0];
                data.areaRegionName = data.areaRegions[1];
                data.areaProvinceName = data.areaProvinces[1];
                data.areaCityName = data.areaCitys[1];
              }
            } else {
              if (data.areaCitys) {
                data.areaRegion = data.areaRegions[0];
                data.areaProvince = data.areaProvinces[0];
                data.areaCity = data.areaCitys[0];
                data.areaRegionName = data.areaRegions[1];
                data.areaProvinceName = data.areaProvinces[1];
                data.areaCityName = data.areaCitys[1];
              }
            }
          } else {
            _s = false;
          }
        });
        return _s;
      });
      statu = statu.every((item) => item === true);

      if (statu) {
        // if(!data.businessLicenseNum||!data.businessLicensePic)return
        if (!this.agreeStatu)
          return this.$message({
            type: "warning",
            message: "请勾选服务协议！",
          });
        data.idCard = data.idCard.replace(/\s+/g, "");
        data.businessLicenseNum = data.businessLicenseNum.replace(/\s+/g, "");
        if (this.$route.query.type) {
          data.companyId = this.$route.query.id;
          updateBuyer(data).then((res) => {
            _this.$router.push({
              name: "register-success",
              query: { type: "4" },
            });
          });
        } else {
          userBuyer(data).then((res) => {
            _this.$router.push({
              name: "register-success",
              query: { type: "4" },
            });
            // let url = get_url_prefix({environment: global.appConfig.environment, appKey: 'default'})
            // window.location.href = url
          });
        }
      } else {
        this.$nextTick(() => {
          let firstEle = document.getElementsByClassName(
            "el-form-item__error"
          )[0];
          document.documentElement.scrollTop =
            document.documentElement.scrollTop +
            firstEle.getBoundingClientRect().top -
            firstEle.parentElement.offsetHeight -
            18;
        });
      }
    },
    //获取城市列表
    _getInlandArea(id, callback) {
      getInlandAreaChildListByParentIdResponse({ id: id }).then((res) => {
        if (res.code === SUCCESS_CODE) {
          callback(res.areaTreeResult);
        }
      });
    },
    //选中大区
    _getArea(val) {
      this.selectCityStatu = true;
      this._getInlandArea(val[0], (res) => {
        this.formData.areaProvinces ? (this.formData.areaProvinces = "") : "";
        this.formData.areaCitys ? (this.formData.areaCitys = "") : "";
        this.$set(this.siteList, "province", res);
        this.$set(this.siteList, "city", []);
      });
    },
    //选中省份
    _getProvince(val) {
      this._getInlandArea(val[0], (res) => {
        this.formData.areaCitys ? (this.formData.areaCitys = "") : "";
        this.$nextTick(() => {
          this.$set(this.siteList, "city", res);
        });
      });
    },
  },
};
</script>
<style lang="less" scoped>
.head-banner {
  width: 100%;
  height: 100px;
  background: url("//yinzhilv-front-admin-bucket.oss-cn-beijing.aliyuncs.com/default-v2/distributor/buyerRegisterNav.png")
    no-repeat;
  background-size: cover;
  background-position: center right;
}

.code-auth {
  img {
    height: 35px;
    margin-right: 5px;
    border: 1px solid #ccc;
  }

  /deep/ .el-input {
    input {
      height: 35px;
      border-radius: 0;
    }
  }
}

.form-data-info {
  width: 70%;

  .form-data-input {
    padding: 30px 40px;
    margin-bottom: 20px;
    border: 1px solid #f3f3f3;
    font-size: 14px;
    color: #606266;

    .form-label {
      display: inline-block;
      width: 120px;
      text-align: right;
      padding-right: 12px;
    }

    /deep/ .el-input {
      input {
        height: 35px;
        border-radius: 0;
      }
    }
  }

  .el-button {
    background: #237dc8;
  }

  .code-btn {
    width: 180px;
    background: #237dc8;
    color: white;
  }

  .form-data-submit {
    .form-data-sub-box {
      width: 68%;
      margin: auto;

      .form-data-sub-text {
        font-size: 14px;
        color: #606266;
        padding: 20px 0;

        span {
          padding-left: 10px;
        }
      }
    }
  }

  .form-item-card {
    margin-bottom: 10px;

    .form-item-card-title {
      background: #f2f2f2;
      color: #afafaf;
      text-align: center;
      margin-bottom: 10px;
    }
  }
}

.el-button {
  border-radius: 0;
}

.form-data-head {
  height: 40px;
  line-height: 40px;
  color: #e5e5e5;
  background: #237dc8;
  padding-left: 30px;
}

.form-data-text {
  width: 28%;
  margin-left: 2%;

  .text-box {
    margin-bottom: 30px;
  }

  ul {
    padding: 30px;
    border: 1px solid #f3f3f3;

    li {
      list-style: none;
      font-size: 14px;
      color: #a8a8a8;
      padding: 13px 0;
      line-height: 22px;
      text-align: justify;
    }
  }
}

.content {
  display: flex;
  width: 1200px;
  margin: auto;
  margin-top: 30px;
}
.nav-btn {
  color: #666;
  font-size: 16px;
  display: flex;
  justify-content: center;
  div {
    display: flex;
    justify-content: center;
  }
  span {
    cursor: pointer;
    padding: 8px 30px;
    margin: 30px 10px;
    border: 1px solid #dfdfdf;
    &:hover {
      border-color: #237dc8;
      color: #237dc8;
    }
  }
}
.nav-active {
  color: #237dc8;
  border-color: #237dc8 !important;
}
.user_type {
  display: flex;
  justify-content: center;
  margin-bottom: 20px;
}
.warning {
  width: 1200px;
  margin: auto;
  padding: 40px 0;
  font-size: 17px;
  color: #666;
  font-weight: bold;
  display: flex;
  align-items: center;
  i {
    font-size: 23px;
    color: red;
    margin-right: 10px;
  }
}

.content {
  .avatar-uploader {
    width: 180px;
  }
  /deep/.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  /deep/.avatar-uploader .el-upload:hover {
    border-color: #409eff;
  }
  /deep/.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  /deep/.avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
}
</style>
